import $ from 'jquery';

export default function (area, closeElement) {
  const $area = $(area);
  const $closeElement = $(closeElement);

  $('body').on('keydown', area, focusElements).on('keyup', ':not('+area+')', moveFocusToClose);

  function focusElements(event) {
    const $this = $(this);

    if (event.keyCode === 27) { // esc
      $closeElement.trigger('click');
    }

    if (event.keyCode === 9) { // tab
      // jQuery formatted selector to search for focusable items
      const focusableElementsString = "a[href], area[href], input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), object, embed, *[tabindex], *[contenteditable]";

      // get list of all children elements in given object
      const children = $this.find('*');

      // get list of focusable items
      const focusableItems = children.filter(focusableElementsString).filter(':visible');

      // get currently focused item
      const focusedItem = $(document.activeElement);

      // get the number of focusable items
      const numberOfFocusableItems = focusableItems.length;

      const focusedItemIndex = focusableItems.index(focusedItem);

      if (!event.shiftKey && (focusedItemIndex === numberOfFocusableItems - 1)) {
        focusableItems.get(0).focus();
        event.preventDefault();
      }
      if (event.shiftKey && focusedItemIndex === 0) {
        focusableItems.get(numberOfFocusableItems - 1).focus();
        event.preventDefault();
      }
    }
  }

  function moveFocusToClose(event) {
    const focusedItem = $(document.activeElement);
    const inModal = !!focusedItem.parents($area).length;

    if (event.keyCode === 9 && inModal === false) { // tab
      $closeElement.focus();
    }
  }
}
